import {createContext} from "react";
import {initialUserObj} from "./User";
import {IUser} from "./edit/EditUser";

export const UsersContext = createContext({
    user: initialUserObj,
    setUser: (user: IUser) => {}
})